var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChef({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m768 128q-8.4 0-16.7 0.6-8.4 0.6-16.6 1.9-8.3 1.2-16.5 3.1-8.1 1.9-16.1 4.3c-20.1-32.3-48.2-58.9-81.4-77.3-33.3-18.5-70.7-28.2-108.7-28.2-38 0-75.4 9.7-108.7 28.2-33.2 18.4-61.3 45-81.4 77.3-59.8-18.9-124.7-11.8-179.1 19.4-54.4 31.3-93.1 83.9-106.9 145.1-13.7 61.2-1.2 125.3 34.5 176.8 35.8 51.5 91.5 85.7 153.6 94.2v354.6c0 85.4 576 85.4 576 0v-354.6c55.7-8.4 106.1-37.6 141.3-81.6 35.2-44 52.4-99.7 48.4-155.9-4-56.1-29.1-108.7-70.2-147.3-41.1-38.5-95.2-60.2-151.5-60.6zm-425.3 409.9l-13.4-128c-1-13.3 3.3-26.5 11.9-36.7 8.5-10.2 20.8-16.7 34-18.2 13.3-1.4 26.6 2.4 37.1 10.6 10.6 8.2 17.5 20.2 19.4 33.4l13.4 128c1 13.4-3.3 26.5-11.9 36.8-8.5 10.2-20.8 16.7-34 18.1-13.3 1.4-26.6-2.4-37.1-10.6-10.6-8.2-17.5-20.2-19.4-33.4zm352-128l-13.4 128c-1.9 13.2-8.8 25.2-19.4 33.4-10.5 8.2-23.8 12-37.1 10.6-13.2-1.4-25.5-7.9-34-18.1-8.6-10.3-12.9-23.4-11.9-36.8l13.4-128c1.8-13.3 8.7-25.4 19.3-33.7 10.6-8.3 24-12.1 37.4-10.7 13.4 1.5 25.6 8.1 34.2 18.5 8.5 10.4 12.7 23.7 11.5 37.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChef);
export default __webpack_public_path__ + "static/media/chef.026a9506e2c31bd4635c637a34c988ea.svg";
export { ForwardRef as ReactComponent };